import type { DownloadEvidenceDTO, DownloadAppDTO } from '../types/assignments.types';

function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, i)).toFixed(1)} ${units[i]}`;
}

function formatDateTime(iso: string | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
}

interface DownloadEvidenceCardProps {
  evidence: DownloadEvidenceDTO;
  app?: DownloadAppDTO | null;
}

function Row({ label, value, mono }: { label: string; value: string; mono?: boolean }) {
  return (
    <div className="flex items-start py-2 border-b border-gray-100 last:border-b-0">
      <span className="w-36 shrink-0 text-xs text-gray-500">{label}</span>
      <span className={`text-sm text-gray-900 break-all ${mono ? 'font-mono tabular-nums' : ''}`}>{value || '-'}</span>
    </div>
  );
}

export function DownloadEvidenceCard({ evidence, app }: DownloadEvidenceCardProps) {
  return (
    <section className="space-y-3">
      <h3 className="text-base font-medium text-gray-900">下载凭证</h3>

      {app && (
        <div className="flex items-center gap-3 py-2">
          {app.artwork_url && (
            <img src={app.artwork_url} alt={app.name} className="h-10 w-10 rounded-lg" />
          )}
          <div>
            <p className="text-sm font-medium text-gray-900">{app.name}</p>
            <p className="text-xs text-gray-500">{app.developer_name} &middot; {app.genre}</p>
          </div>
        </div>
      )}

      <div className="border border-gray-200 rounded-md px-4">
        <Row label="Bundle ID" value={evidence.bundle_id} mono />
        <Row label="App 版本" value={evidence.app_version} mono />
        <Row label="文件大小" value={`${formatBytes(evidence.file_size_bytes)} (${evidence.file_size_bytes.toLocaleString()} bytes)`} mono />
        <Row label="MD5 校验" value={evidence.md5_hash} mono />
        <Row label="设备 GUID" value={evidence.device_guid} mono />
        <Row label="下载开始" value={formatDateTime(evidence.download_started_at)} />
        <Row label="下载完成" value={formatDateTime(evidence.download_completed_at)} />
      </div>
    </section>
  );
}
